import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Navigation, NavigationItem } from '@appkit4/react-components/navigation';
import { Avatar } from '@appkit4/react-components/esm/avatar';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import $ from 'jquery';
const Sidebar: React.FC = () => {
  const [IsopenNav, setIsopenNav] = useState<Boolean>(true);
  const roles = useSelector((state: RootState) => state.auth.roles)
  const [collapsed, setCollapsed] = React.useState(false);
  const [selectedKey, setSelectedKey] = useState(localStorage.getItem('selectedNavIndex') || '0');
  const navigate = useNavigate();
  const location = useLocation();

  const [idmEnabled, setidmEnabled] = React.useState(false);
  const [draftgenerationEnabled, setdraftgenerationEnabled] = React.useState(false);
  const [benchmarkingEnabled, setbenchmarkingEnabled] = React.useState(false);
  const [helpEnabled, sethelpEnabled] = React.useState(true);
  const [navList, setnavList] = React.useState<NavigationItem[]>([{
    name: 'Intelligent Document Management',
    prefixIcon: 'doc',
  }]);

  useEffect(() => {
    localStorage.setItem('selectedNavIndex', selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (roles.length > 0) {
      let idm = roles.includes('idm')
      let draftgen = roles.includes('dg')
      let benchmarking = roles.includes('benchmarking')
      let help = true; // Common page for all users
      const allNavList: NavigationItem[] = [
        {
          name: 'Intelligent Document Management',
          prefixIcon: 'doc',
        },
        {
          name: 'Draft Generation',
          prefixIcon: 'pen',
        },
        {
          name: 'Benchmarking',
          prefixIcon: 'bar-chart',
        },
        {
          name: 'Help',
          prefixIcon: 'information',
        }
      ];
      const navlistarr = allNavList.filter(item =>
        (item.name === 'Intelligent Document Management' && idm) ||
        (item.name === 'Draft Generation' && draftgen) ||
        (item.name === 'Benchmarking' && benchmarking) ||
        (item.name === 'Help' && help)
      );
      setnavList(navlistarr)
      setidmEnabled(idm)
      setdraftgenerationEnabled(draftgen)
      setbenchmarkingEnabled(benchmarking)
      sethelpEnabled(help)
    }
  }, [idmEnabled, benchmarkingEnabled, draftgenerationEnabled, helpEnabled, roles]);

  // Explicitly typing the navigationPaths variable
  const navigationPaths: { [key: string]: string } = {
    'Intelligent Document Management': '/docmanagement',
    'Draft Generation': '/draftgeneration',
    'Benchmarking': '/benchmarking',
    'Help': '/help',
  };

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath !== '/home' && currentPath !== '/docmanagement' && currentPath !== '/benchmarking' && currentPath !== '/draftgeneration' && currentPath !== '/help') {
      $('.ap-navigation-wrapper').hide()
    }
    // Find the matching index dynamically from navList
    const foundIndex = navList.findIndex(item => navigationPaths[item.name] === currentPath);
    if (foundIndex !== -1) {
      setSelectedKey(foundIndex.toString()); // Set index dynamically
    } else {
      setSelectedKey('null'); // Default case
    }
  }, [location, navList]);

  const onClickLogo = (event: React.MouseEvent<HTMLElement>) => {
  };

  const onCollapseEvent = (collapsed: boolean, event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
    setCollapsed(collapsed);

    setIsopenNav(!IsopenNav);
    if (IsopenNav) {
      document.body.classList.add('navOpen');
    } else {
      document.body.classList.remove('navOpen');
    }


  };

  const onItemClick = (event: React.SyntheticEvent, item: NavigationItem, key: string) => {
    setSelectedKey(key);
    const path = navigationPaths[item.name];
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className={IsopenNav ? 'ap-navigation-demo-wrapper' : 'ap-navigation-demo-wrapper smlNav'}>
      {(idmEnabled || benchmarkingEnabled || draftgenerationEnabled) ?

        <Navigation
          width={280}
          className="sitedemo"
          hasHeader={false}
          navList={navList}
          showTooltip={true}
          onClickLogo={onClickLogo}
          selectedKey={selectedKey}
          onItemClick={onItemClick}
          onClickCollapseEvent={onCollapseEvent}
          titleTemplate={() => 'Appkit'}
          userTemplate={() => <Avatar className="keyboard-focus" label="VR" disabled={false} role="button"></Avatar>}
        /> : <></>}
    </div>
  );
};

export default Sidebar;
